<template>
  <!-- custom banner -->
  <span
    class="absolute left-0 top-0 w-0 h-0 border-t-purple-600 border-t-[1.25rem] border-r-transparent border-r-[1.25rem]"
  ></span>
</template>
